<template>
  <div class="register-container">
    <!-- 상단 헤더 -->
    <header class="register-header">
      <router-link to="/" class="logo">마이바버샵 파트너스</router-link>
      <div class="user-area">
        <div class="user-info">
          <span class="nickname">{{ nickname }} 님</span>
          <button @click="logout">로그아웃</button>
        </div>
      </div>
    </header>

    <!-- 탭 메뉴 -->
    <div class="tab-container">
      <div class="tab active-tab">입점정보</div>
    </div>

    <div class="register-wrapper compact-wrapper">
      <!-- 기본정보 안내 및 입력 폼을 form-section으로 감싸기 -->
      <p class="section-title">기본정보 <span class="required-mark">(* 필수입력)</span></p>
      <div class="form-section">

        <!-- 매장명 -->
        <label class="form-label"><span class="required">*</span> 매장명</label>
        <input v-model="form.name" placeholder="매장명을 입력하세요" class="form-input full-width" />

        <!-- 전화번호 -->
        <label class="form-label"><span class="required">*</span> 전화번호</label>
        <input
          v-model="form.tel"
          type="text"
          placeholder="010-1234-5678"
          maxlength="13"
          @input="formatPhoneNumber"
          pattern="^010-\d{4}-\d{4}$"
          inputmode="numeric"
          class="form-input full-width"
        />

        <!-- 주소 -->
        <label class="form-label"><span class="required">*</span> 주소</label>
        <div class="address-row">
          <input
            type="text"
            v-model="form.address"
            placeholder="주소 검색 후 자동 입력"
            readonly
            class="form-input full-width"
          />
          <input
            type="text"
            v-model="form.addressDetail"
            placeholder="상세주소 입력"
            class="form-input full-width"
            :class="{ 'error-border': form.addressDetail === '' && triedSubmit }"
            ref="addressDetailInput"
          />
          <button @click="openAddressPopup" class="search-button">검색</button>
        </div>

        <!-- 썸네일 -->
        <label class="form-label"><span class="required">*</span> 썸네일</label>
        <input type="file" @change="handleThumbnailUpload" accept="image/*" class="form-input full-width" />
     
    <!-- 메뉴정보 입력 -->
      <div class="form-group" style="flex-direction: column;" >
        <label class="form-label"><span class="required">*</span>메뉴 정보</label>
          <div v-for="(category, catIndex) in form.menu"
            :key="catIndex"
            style="margin-bottom: 16px;"
            >
        <!--<strong>{{ category.category }}</strong>-->
        <strong style="margin-right: 12px;">{{ category.category }}</strong>
        <div
          v-for="(item, itemIndex) in category.items"
          :key="itemIndex"
          style="display: flex; gap: 8px; margin: 6px 0;"
        >
    <input
      v-model="item.name"
      placeholder="메뉴명"
      class="form-input half-width"
    />
    <input
      v-model="item.price"
      @input="formatMenuPrice(catIndex, itemIndex)"
      placeholder="가격"
      class="form-input half-width"
    />
    <button @click="removeMenuItem(catIndex, itemIndex)">삭제</button>
  </div>
    <button @click="addMenuItem(catIndex)">+ 메뉴 추가</button>
  </div>

        <div style="margin-top: 10px;">
          <select v-model="newCategory" class="form-input full-width">
            <option disabled value="">카테고리 선택</option>
            <option>CUT</option>
            <option>PERM</option>
            <option>COLOR</option>
            <option>기타</option>
          </select>
          <button @click="addCategory">+ 카테고리 추가</button>
        </div>
      </div>
      
      <!-- 영업시간 입력 -->
      <div class="form-group" style="flex-direction: column;">
        <label class="form-label"><span class="required">*</span>영업시간</label>
        <div style="margin-bottom: 12px;">
          <button @click="toggleTimeInputMode">
            {{ timeInputMode === 'time' ? '텍스트 입력모드' : '시간 선택모드' }}
          </button>
        </div>
        <div class="bizhour-row" v-for="(label, dayKey) in days" :key="dayKey">
          <span class="day-label">{{ label }}</span>
          <!-- 영업시간 -->
          <div class="time-field">
            <template v-if="timeInputMode === 'time'">
              <input
                type="time"
                v-model="form.businessHours[dayKey].open"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
               
              />
            </template>
            <template v-else>
              <input
                type="text"
                v-model="form.businessHours[dayKey].open"
                placeholder="HH:mm"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
                  @input="autoFormatTime(dayKey, 'open')"
              />
            </template>
            <span class="tilde">~</span>
            <template v-if="timeInputMode === 'time'">
              <input
                type="time"
                v-model="form.businessHours[dayKey].close"
                :disabled="closedDays[dayKey]"
                style="width: 100px"

              />
            </template>
            <template v-else>
              <input
                type="text"
                v-model="form.businessHours[dayKey].close"
                placeholder="HH:mm"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
                  @input="autoFormatTime(dayKey, 'close')"
              />
            </template>
          </div>
          <!-- 점심시간 -->
          <div class="time-field lunch-field">
            <span class="lunch-label">점심</span>
            <template v-if="timeInputMode === 'time'">
              <input
                type="time"
                v-model="form.businessHours[dayKey].lunchStart"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
              />
            </template>
            <template v-else>
              <input
                type="text"
                v-model="form.businessHours[dayKey].lunchStart"
                placeholder="HH:mm"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
                  @input="autoFormatTime(dayKey, 'lunchStart')"
              />
            </template>
            <span class="tilde">~</span>
            <template v-if="timeInputMode === 'time'">
              <input
                type="time"
                v-model="form.businessHours[dayKey].lunchEnd"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
              />
            </template>
            <template v-else>
              <input
                type="text"
                v-model="form.businessHours[dayKey].lunchEnd"
                placeholder="HH:mm"
                :disabled="closedDays[dayKey]"
                style="width: 100px"
                  @input="autoFormatTime(dayKey, 'lunchEnd')"
              />
            </template>
          </div>
          <!-- 휴무 체크 -->
          <div class="closed-checkbox">
            <input type="checkbox" v-model="closedDays[dayKey]" @change="applyClosedState(dayKey)" />
            <label>휴무</label>
          </div>
        </div>

        <!-- Button to apply Monday's hours to all -->
        <div style="text-align: right; margin-top: 12px;">
          <button class="search-button" @click="applyToAllDays('mon')">
            월요일과 동일하게 전체 요일 적용
          </button>
        </div>
      </div>
</div>

    <!-- 사업자등록증 섹션 제목과 필수 표시를 .form-section 밖으로 이동 -->
    <p class="section-title">사업자등록증 <span class="required-mark">(* 필수입력)</span></p>
    <div class="form-section">
      <div class="form-row" style="margin-bottom: 16px;">
        <label>사업자유형 <span class="required">*</span></label>
        <label><input type="radio" name="businessType" value="개인사업자"> 개인사업자</label>
        <label><input type="radio" name="businessType" value="간이사업자"> 간이사업자</label>
        <label><input type="radio" name="businessType" value="법인사업자"> 법인사업자</label>
      </div>

      <div class="form-row" style="display: flex; align-items: center; gap: 16px; flex-wrap: wrap; margin-bottom: 16px;">
        <label class="form-label" style="min-width: 160px;">대표자(사업자등록증) <span class="required">*</span></label>
        <!--<input type="checkbox" id="sameAsShopOwner">-->
        <label for="sameAsShopOwner" style="margin-right: 12px;">대표자(실제점주)와 동일</label>
       <input
          type="text"
          v-model="form.ownerName"
          placeholder="이름 입력(해외 국적자는 영문명)"
          class="form-input"
          style="flex: 1;"
        />

        <input
          type="text"
          v-model="form.ownerBirth"
          placeholder="생년월일 6자리(주민/외국인등록증 기준)"
          class="form-input"
          maxlength="6"
          inputmode="numeric"
          pattern="^\d{6}$"
          @input="form.ownerBirth = form.ownerBirth.replace(/\D/g, '').slice(0,6)"
          style="flex: 1;"
         />

      </div>

      <div class="form-row address-row" style="margin-bottom: 16px;">
        <label>사업자등록번호 <span class="required">*</span></label>
        <!--<input type="text" v-model="form.bizPart1" placeholder="123" class="form-input" style="max-width: 80px;" />-->
        <input
          type="text"
          v-model="form.bizPart1"
          placeholder="123"
          class="form-input"
          style="max-width: 80px;"
          maxlength="3"
          inputmode="numeric"
          @input="form.bizPart1 = form.bizPart1.replace(/\D/g, '').slice(0,3)"
        />
        
        <!--<input type="text" v-model="form.bizPart2" placeholder="45" class="form-input" style="max-width: 60px;" />-->
        <input
            type="text"
            v-model="form.bizPart2"
            placeholder="45"
            class="form-input"
            style="max-width: 60px;"
            maxlength="2"
            inputmode="numeric"
            @input="form.bizPart2 = form.bizPart2.replace(/\D/g, '').slice(0,2)"
        />

        <!--<input type="text" v-model="form.bizPart3" placeholder="67890" class="form-input" style="max-width: 100px;" />-->
        <input
          type="text"
          v-model="form.bizPart3"
          placeholder="67890"
          class="form-input"
          style="max-width: 100px;"
          maxlength="5"
          inputmode="numeric"
          @input="form.bizPart3 = form.bizPart3.replace(/\D/g, '').slice(0,5)"
         />

        <button class="search-button" @click="checkDuplicateBizNumber">중복확인</button>
      </div>

      <div class="form-row" style="margin-bottom: 16px;">
        <label>사업 종목 <span class="required">*</span></label>
        <input type="text" value="이용업" class="form-input full-width" readonly />
      </div>
    <!--
      <div class="form-row" style="margin-bottom: 16px;">
        <label>사업자등록증</label>
        <input type="file" accept=".jpg,.gif,.pdf" class="form-input" />
        <button class="search-button">첨부</button>
      </div>
      -->
      <div class="form-row" style="margin-bottom: 16px;">
      <label>사업자등록증</label>
      <input type="file" @change="handleRegistrationUpload" accept=".jpg,.jpeg,.gif,.png,.pdf" class="form-input" />
      <span v-if="businessFile" style="margin-left: 12px;">✅ {{ businessFile.name }}</span>
    </div>

    </div>
    
    <!-- ✅ 관리자 정보 form-section 추가 위치 -->
    <p class="section-title">관리자정보 <span class="required-mark">(* 필수입력)</span></p>
    <section class="form-section">
     <div class="form-group horizontal-align">
      <label class="form-label"><span class="required">*</span> 이름</label>
        <input
          v-model="manager.name"
          placeholder="이름을 입력해주세요"
          class="form-input short-input"
        />
        <div class="checkbox-inline">
          <input type="checkbox" v-model="sameAsOwner" @change="applyOwnerName" id="sameAsOwner" />
                <label>대표자(실제점주)와 동일</label>
        </div>
      </div>

      <div class="form-group phone-inputs">
        <label class="form-label"><span class="required">*</span> 휴대폰번호</label>
        <div class="phone-input-box">
          <input class="form-input" v-model="manager.phone1" maxlength="3" :readonly="isPhoneVerified" />
          <span>-</span>
          <input class="form-input" v-model="manager.phone2" maxlength="4" :readonly="isPhoneVerified" />
          <span>-</span>
          <input class="form-input" v-model="manager.phone3" maxlength="4" :readonly="isPhoneVerified" />

          <template v-if="!isPhoneVerified">
            <button 
              class="verify-button"
              style="background-color: #007bff; color: white; border-radius: 20px; padding: 8px 16px;"
              @click="verifyPhone"
            >
              전화번호 인증
            </button>
          </template>
          <template v-else>
            <span class="verification-complete-text">✅ 인증완료</span>
          </template>

        </div>
      </div>
    </section>
      <table class="contract-table modern-contract">
      <thead>
        <tr>
          <th>수수료구분</th>
          <th>입점료</th>
          <th>사용료</th>
          <th>서비스수수료</th>
          <th>결제수수료</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Type B</td>
          <td>0</td>
          <td>0</td>
          <!--2027년부터 3프로<td>기존 0% / 신규 10%</td>-->
          <td>0% (2026년 연말까지)</td>
          <td>영중소 등급별 차등 적용</td>
        </tr>
      </tbody>
    </table>

    <!-- 정산 입금 계좌정보 섹션  
    <p class="section-title settlement-title">정산금 입금 계좌정보 <span class="required-mark">(* 필수입력)</span></p>
    <div class="form-section settlement-section">
 
  <div class="form-row" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 계좌번호</label>
    <select v-model="settlement.bank" class="form-input" style="max-width: 120px;">
      <option disabled value="">은행</option>
      <option>국민은행</option>
      <option>신한은행</option>
      <option>우리은행</option>
      <option>하나은행</option>
      <option>농협</option>
      <option>카카오뱅크</option>
    </select>
    <input
      v-model="settlement.account"
      placeholder="계좌번호를 입력해주세요"
      class="form-input"
      style="flex: 1;"
      inputmode="numeric"
      @input="settlement.account = settlement.account.replace(/[^0-9]/g, '')"
    />
    <button class="search-button">계좌실명인증</button>
  </div>
  <div class="form-row" style="margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 예금주</label>
    <input v-model="settlement.holder" placeholder="이름을 입력해주세요" class="form-input full-width" />
  </div>
 <div class="form-row" style="margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 통장사본</label>
    <input type="file" @change="handleAccountFileUpload" accept=".jpg,.jpeg,.gif,.png,.pdf" />
    <button class="search-button">첨부</button>
  </div>
  </div>
-->
  <p class="section-title settlement-title">정산금 입금 계좌정보 <span class="required-mark">(* 필수입력)</span></p>
<div class="form-section settlement-section">

  <div class="form-row" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 계좌번호</label>
    
  <select v-model="settlement.bank" class="form-input" style="max-width: 120px;" :disabled="isAccountVerified">
      <option disabled value="">은행선택</option>
      <option v-for="(name, code) in bankCodes" :key="code" :value="code">
        {{ name }}
      </option>
   </select>


    <input
      v-model="settlement.account"
      placeholder="계좌번호를 입력해주세요 ('-' 제외)"
      class="form-input"
      style="flex: 1;"
      inputmode="numeric"
      @input="settlement.account = settlement.account.replace(/[^0-9]/g, '')"
      :readonly="isAccountVerified"
    />

    <template v-if="!isAccountVerified">
      <button class="search-button" @click="startAccountVerification">계좌실명인증</button>
    </template>
    <template v-else>
      <span class="verification-complete-text" style="font-weight: bold; color: #28a745;">✅ 인증완료</span>
    </template>
  </div>

  <div class="form-row" style="margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 예금주</label>
    <input 
      v-model="settlement.holder" 
      placeholder="이름을 입력해주세요" 
      class="form-input full-width"
      :readonly="isAccountVerified"
    />
  </div>
  <div class="form-row" style="margin-bottom: 16px;">
    <label class="form-label"><span class="required">*</span> 통장사본</label>
    <input type="file" @change="onBankCopyChange" accept=".jpg,.jpeg,.gif,.png,.pdf" class="form-input full-width" />
    <span v-if="bankCopyFile" style="margin-left: 12px;">✅ {{ bankCopyFile.name }}</span>
  </div>
    </div>
    <!-- 약관 동의 -->
 <div class="form-section">
    <label>
      <input type="checkbox" v-model="agreements.terms" />
      판매자 이용약관 (필수)
    </label>
    <button @click="openModal('terms')">내용 보기</button>

    <label>
      <input type="checkbox" v-model="agreements.privacy" />
      개인정보 수집 및 이용 동의 (필수)
    </label>
    <button @click="openModal('privacy')">내용 보기</button>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <h3>{{ modalTitle }}</h3>
        <div v-html="modalContent"></div>
        <button @click="closeModal">닫기</button>
      </div>
    </div>
    </div>

      <!-- 등록 버튼 -->
      <div class="submit-row">
        <button @click="submitForm" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '매장 등록' }}
        </button>
      </div>
      <div v-if="showPopup" class="popup-overlay">
        <div class="popup-content">
          <p>✅ 매장 등록이 완료되었습니다.</p>
          <button @click="goToDashboard">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global daum */
import axios from 'axios';
import { marked } from 'marked';
import bankCodes from '@/assets/bankCodes.json';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  data() {
    return {
     // ✅ 아래 두 항목 추가
      bankCodes,  // 그대로 json 객체를 data 에 넣음
      isAccountVerified: false, // 계좌인증 완료 상태를 저장할 변수
      settlement: {
        bank: '',       // 은행 '코드'가 여기에 저장됩니다.
        account: '',
        holder: '',
        accountFile: null
      },
      timeInputMode: 'time',
      showModal: false,
      modalContent: '',
      modalTitle: '',
      agreements: {
        terms: false,
        privacy: false
      },
      
      sameAsOwner: false,
      ownerName: '', // 예: 등록 시 입력한 점주 이름
      isPhoneVerified: false, // ✅ 이 줄을 추가하세요.
      manager: {
        name: '',
        phone1: '',
        phone2: '',
        phone3: ''
      },
      user: JSON.parse(localStorage.getItem('user') || '{}'),  // ✅ 이 줄 추가!
      days: {
        mon: '월',
        tue: '화',
        wed: '수',
        thu: '목',
        fri: '금',
        sat: '토',
        sun: '일'
      },
      closedDays: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false
      },
      form: {
        user: {},
        nickname: "게스트",
        id: Date.now(),
        name: '',
        tel: '',
        region: '',
        address: '',
        addressDetail: '',
        selectedSido: '',
        selectedSigungu: '',
        x: '',
        y: '',
        menu: [],
        businessHours: {
          mon: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          tue: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          wed: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          thu: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          fri: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          sat: { open: '', close: '', lunchStart: '', lunchEnd: '' },
          sun: { open: '', close: '', lunchStart: '', lunchEnd: '' }
        },
        businessType: '',
        ownerName: '',
        ownerBirth: '',
        bizPart1: '',
        bizPart2: '',
        bizPart3: '',
         // ✅ 새로 추가할 항목
      ownerUUID: '',  // 로그인된 사용자 UUID를 저장할 곳
      },
      triedSubmit: false,
      businessFile: null,
      newCategory: '',
      isSubmitting: false,
      formSubmitted: false,
      barbershopId: null,
      selectedFile: null,    // Added to hold the selected file temporarily
      showPopup: false,
    };
  },
  created() {
    const storedUser = JSON.parse(localStorage.getItem('user')) || {};
    //this.user = storedUser;
    this.nickname = storedUser.nickname || "게스트";
    // 🟡 [Kakao 로그인 후 UUID 발급 및 저장] - 로그인 성공 시가 아니라면 이곳이 아님
    // 👉 Kakao 로그인 성공 시 UUID 저장 확인 로그
    if (localStorage.getItem('userUUID')) {
      console.log("🟩 [BarbershopRegisterView] userUUID 존재:", localStorage.getItem('userUUID'));
    } else {
      console.log("🟥 [BarbershopRegisterView] userUUID 없음: Kakao 로그인에서 UUID 발급/저장 확인 필요");
    }
  },
  mounted() {
      // 인증 팝업(자식창)에서 보내는 메시지를 받기 위한 이벤트 리스너 등록
    window.addEventListener('message', this.handleAccountVerificationResult);
    const storedUUID = localStorage.getItem('userUUID');
    if (storedUUID) {
      this.form.ownerUUID = storedUUID;
      console.log('🧑‍💼 ownerUUID 설정됨:==========', storedUUID);
    } else {
      const socialId = localStorage.getItem('kakaoId');
      const platform = localStorage.getItem('platform');
      if (socialId && platform) {
        axios.post('/api/users/uuid', { socialId, platform })
          .then(res => {
            this.form.ownerUUID = res.data.uuid;
            console.log('✅ 서버에서 받아온 UUID 설정됨:', res.data.uuid);
            localStorage.setItem('userUUID', res.data.uuid);
          })
          .catch(err => {
            console.error('❌ UUID 서버 요청 실패:', err);
          });
      }
      
    }

    if (!window.daum?.Postcode) {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.onload = () => console.log('Daum Postcode script loaded');
      document.head.appendChild(script);
    }
    window.addEventListener('message', (event) => {
        if (event.data.type === 'PASS_SUCCESS') {
          alert(`본인인증 완료! 인증 전화번호: ${event.data.phone}`);
          // 여기서 부모 스토어에 인증 상태 저장하거나, 서버에 POST 해도 됨
           this.isPhoneVerified = true; // ✅ 이 줄을 추가하세요.
        }
      });



  },
  computed: {
      canSubmit() {
          return this.agreements.terms && this.agreements.privacy;
    }
  },
   beforeUnmount() {
    // 컴포넌트가 사라질 때 이벤트 리스너를 제거하여 메모리 누수를 방지
    window.removeEventListener('message', this.handleAccountVerificationResult);
  },
  methods: {
     onBankCopyChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.bankCopyFile = file;
    console.log("✅ 통장사본 선택됨:", file.name);
  },
      // '계좌실명인증' 버튼이 호출할 메소드 (axios 로직 추가)
    async startAccountVerification() {
      if (!this.settlement.bank || !this.settlement.account || !this.settlement.holder) {
        alert('은행, 계좌번호, 예금주를 모두 입력해주세요.');
        return;
      }

      try {
        // 1. 우리 Node.js 서버의 API(/api/inicis/start-verification)를 호출합니다.
        //    서버는 이 요청을 받아 암호화 등 준비 작업을 수행합니다.
        const response = await axios.post('/api/inicis/start-verification', {
          bankCd: this.settlement.bank,
          userAcctNo: this.settlement.account,
          userName: this.settlement.holder
        });

        // 2. 서버로부터 받은 데이터(authData)로 동적 폼을 만들어 이니시스에 보냅니다.
        const authData = response.data;
        const popupName = 'account_auth_popup';
        // 이니시스 권장 팝업 사이즈 적용
        const popupOptions = 'width=400,height=620,resizable=yes,scrollbars=yes'; 
        
        const popup = window.open('', popupName, popupOptions);
        if (!popup) {
          alert("팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.");
          return;
        }

        const form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', authData.requestURL); // 서버가 알려준 이니시스 요청 주소
        form.setAttribute('target', popupName);           // 팝업창이 타겟

        // 서버가 보내준 모든 데이터를 form의 hidden input으로 추가
        for (const key in authData) {
          if (key !== 'requestURL') {
            const input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', key);
            input.setAttribute('value', authData[key]);
            form.appendChild(input);
          }
        }

        document.body.appendChild(form);
        form.submit(); // 이니시스 팝업창으로 데이터 전송
        document.body.removeChild(form); // 임시로 만든 폼 제거

      } catch (error) {
        console.error('❌ 계좌인증 준비 실패:', error);
        alert('계좌인증 중 오류가 발생했습니다. 서버 로그를 확인해주세요.');
      }
    },
     // 팝업에서 보낸 결과를 처리할 메소드 (상세 로직 추가)
    handleAccountVerificationResult(event) {
      // 보안: 실제 서비스에서는 event.origin을 확인하여 신뢰할 수 있는 출처의 메시지만 처리해야 합니다.
      // 예: if (event.origin !== 'https://내도메인.com') return;
      
      const { type, success, message, verifiedHolderName } = event.data;

      // 우리가 정의한 타입의 메시지가 아니면 무시
      if (type !== 'ACCOUNT_VERIFICATION_COMPLETE') {
        return;
      }

      if (success) {
        alert('✅ 계좌인증에 성공했습니다.');
        this.isAccountVerified = true;
        // 은행에서 확인된 실제 예금주명으로 예금주 입력란을 업데이트
        this.settlement.holder = verifiedHolderName;
      } else {
        alert(`❌ 계좌인증 실패: ${message}`);
        this.isAccountVerified = false;
      }
    },
    
    toggleTimeInputMode() {
        this.timeInputMode = this.timeInputMode === 'time' ? 'text' : 'time';
      },
       async openModal(type) {
      const path =
        type === 'terms'
          ? '/terms/terms.md'
          : '/terms/privacy.md';

      this.modalTitle = type === 'terms' ? '판매자 이용약관' : '개인정보 수집 및 이용 동의';
        try {
        const res = await axios.get(path);
        this.modalContent = marked(res.data); // ✅ 마크다운 → HTML 변환
        this.showModal = true;
      } catch (err) {
        console.error("❌ 약관 파일 로딩 실패:", err);
        this.modalContent = '<p>약관을 불러오는 데 실패했습니다.</p>';
        this.showModal = true;
      }
    },
    closeModal() {
      this.showModal = false;
    },
    handleAccountFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.settlement.accountFile = file;
    },


    // 통장사본 업로드 메소드
    /*
    async uploadBankCopy() {
      if (!this.barbershopId) {
        alert("먼저 매장을 등록해주세요.");
        return;
      }
      if (!this.bankCopyFile) {
        alert("통장사본 파일을 선택해주세요.");
        return;
      }

      const formData = new FormData();
      formData.append('file', this.bankCopyFile);

      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/barbershops/${this.barbershopId}/upload-bank-copy`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true
          }
        );
        this.bankCopyUrl = response.data.imageUrl;
        console.log("✅ 통장사본 업로드 완료:", this.bankCopyUrl);
        alert("통장사본 업로드가 완료되었습니다.");
      } catch (err) {
        console.error("❌ 통장사본 업로드 실패:", err.response?.data || err);
        alert("업로드에 실패했습니다.");
      }
    },
*/
  applyOwnerName() {
    console.log("📌 대표자 이름:=================", this.form.ownerName);
    if (this.sameAsOwner) {
      this.manager.name = this.form.ownerName; // 또는 this.form.name
      console.log("✅ 관리자 이름으로 적용됨:", this.manager.name);
    } else {
      this.manager.name = '';
       console.log("🔄 체크 해제 → 관리자 이름 초기화");
    }
  },
 async verifyPhone() {
      const popupName = 'pass_auth_popup';
      const popupOptions = 'width=500,height=700,resizable=yes,scrollbars=yes';

      // 1. 먼저 빈 팝업을 엽니다. (팝업 차단 회피)
      // 이 시점에 팝업은 about:blank 상태입니다.
      const popup = window.open('', popupName, popupOptions);
      if (!popup) {
        alert("팝업이 차단되었습니다. 브라우저 설정에서 이 사이트의 팝업을 허용해주세요.");
        return;
      }

      try {
        // 2. 백엔드에 인증 데이터를 요청합니다.
       //const response = await axios.get('/api/pass/init');
       // ✅ [수정] GET 대신 POST로 변경하고, 사용자 정보를 body에 담아 보냅니다.
       // [3] ✅ POST 방식으로 사용자 정보를 백엔드에 전달
        const response = await axios.post('/api/pass/init', {
          userName: this.manager.name,
          userPhone: `${this.manager.phone1}${this.manager.phone2}${this.manager.phone3}`,
          userBirth: this.form.ownerBirth || '' // 생년월일 필드가 있다면 전달
        });
        
       const authData = response.data;

        // 3. 동적으로 form을 생성합니다.
        const form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', authData.actionUrl);
        form.setAttribute('target', popupName); // 타겟을 미리 열어둔 팝업 이름으로 지정

        // 4. 백엔드에서 받은 데이터로 input들을 생성하여 form에 추가합니다.
        for (const key in authData) {
          if (key !== 'actionUrl') { // actionUrl은 form의 속성이므로 제외
            const input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', key);
            input.setAttribute('value', authData[key]);
            form.appendChild(input);
          }
        }

        // 5. 생성된 form을 body에 추가하고 즉시 submit한 후, 제거합니다.
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

      } catch (error) {
        console.error('❌ 본인인증 데이터 요청 실패:', error);
        alert('본인인증 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        popup.close(); // 오류 발생 시 열어둔 팝업을 닫습니다.
      }
    },

      toRegionKey(sido, sigungu) {
      if (!sido || !sigungu) return 'cheonan_test2';
      const key = sigungu.trim().replace(/\s/g, '').toLowerCase();
      return `${key}_test`;
    },

      normalizeSido(sido) {
      const map = {
        '서울': '서울특별시',
        '부산': '부산광역시',
        '대구': '대구광역시',
        '인천': '인천광역시',
        '광주': '광주광역시',
        '대전': '대전광역시',
        '울산': '울산광역시',
        '세종': '세종특별자치시',
        '경기': '경기도',
        '강원': '강원도',
        '충북': '충청북도',
        '충남': '충청남도',
        '전북': '전라북도',
        '전남': '전라남도',
        '경북': '경상북도',
        '경남': '경상남도',
        '제주': '제주특별자치도'
      };
      return map[sido] || sido;
    },
     
  formatMenuPrice(catIndex, itemIndex) {
    const item = this.form.menu?.[catIndex]?.items?.[itemIndex];
    if (!item) return;

    const onlyNums = item.price.toString().replace(/[^\d]/g, '');
    item.price = onlyNums.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
    autoFormatTime(dayKey, type) {
      let raw = this.form.businessHours[dayKey][type];
      if (typeof raw !== 'string') return;

      raw = raw.replace(/[^\d]/g, ''); // 숫자만 남기기
      if (raw.length === 4) {
        const formatted = raw.slice(0, 2) + ':' + raw.slice(2);
        this.form.businessHours[dayKey][type] = formatted;
      }
    },
 
    logout() {
      localStorage.removeItem('user');
      this.$router.push('/');
    },
    async openAddressPopup() {
      new daum.Postcode({
        oncomplete: async (data) => {
          //this.form.region = `${data.sido} ${data.sigungu}`;
          this.form.address = data.address;
          this.form.addressDetail = data.addressDetail;

           // ✅ 시/도와 시군구 자동 추출
          const sido = data.sido || data.address.split(' ')[0];         // 예: '충청남도'
          const sigungu = data.sigungu || data.address.split(' ')[1];   // 예: '천안시'

          this.form.selectedSido = this.normalizeSido(data.sido || data.address.split(' ')[0]);  // ✅ 수정 필수!
          this.form.selectedSigungu = data.sigungu || data.address.split(' ')[1];


          console.log('🧭 자동 설정된 시/도:', sido);
          console.log('🧭 자동 설정된 시군구:', sigungu);

          //const query = encodeURIComponent(data.roadAddress);
          try {
          const response = await fetch(`/api/search/address?query=${encodeURIComponent(data.roadAddress)}`);

          if(!response.ok){
            throw new Error('서버 응답 오류: ${response.status}');
          }
          const json = await response.json();
          const result = json.documents[0];
          if (result) {
            this.form.x = parseFloat(result.x);
            this.form.y = parseFloat(result.y);
            console.log('✅ 좌표 변환 성공:', this.form.x, this.form.y);
          }
        } catch(error){
         console.error("❌ 주소 좌표 변환 실패:", error);
        alert("주소를 좌표로 변환하는 중 오류가 발생했습니다. 서버 로그를 확인해주세요.");
        }
        // --- ▲▲▲▲▲ 여기까지가 핵심 수정 부분입니다 ▲▲▲▲▲ ---
      }
      }).open();
    },


    formatPhoneNumber(event) {
        let raw = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 남김
     if (raw.length <= 3) {
          event.target.value = raw;
        } else if (raw.length <= 7) {
          event.target.value = raw.replace(/(\d{3})(\d+)/, '$1-$2');
        } else {
          event.target.value = raw.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3').slice(0, 13);
        }
        this.form.tel = event.target.value;
      },
       convertAddressToCoords(address) {
      axios.get('/api/search/address', {
        params: { query: address },
        
      }).then(res => {
        const result = res.data.documents[0];
        if (!result) {
          alert('좌표를 찾을 수 없습니다. 주소를 다시 입력해주세요.');
          return;
        }
        if (result?.address) {
          this.form.x = result.address.x;
          this.form.y = result.address.y;
          console.log('X:', this.form.x, 'Y:', this.form.y);
        }
      }).catch(err => {
        alert('좌표 조회 실패');
        console.error(err);
      });
    },
 
// 썸네일 등록
handleThumbnailUpload(event) {
  const file = event.target.files[0];
  if (!file) return;
  this.selectedFile = file;
},

// 사업자등록증 등록
 handleRegistrationUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        this.businessFile = file;
  },



addCategory() {
  if (!this.newCategory) return;
  const exists = this.form.menu.find(c => c.category === this.newCategory);
  if (!exists) {
    this.form.menu.push({ category: this.newCategory, items: [] });
    this.newCategory = '';
    // Apply Mon's business hours/lunch/closed to all days

  }
},

    applyToAllDays(sourceDay) {
      const source = this.form.businessHours[sourceDay];
      Object.keys(this.form.businessHours).forEach(day => {
        if (day !== sourceDay) {
          this.form.businessHours[day].open = source.open;
          this.form.businessHours[day].close = source.close;
          this.form.businessHours[day].lunchStart = source.lunchStart;
          this.form.businessHours[day].lunchEnd = source.lunchEnd;
          this.closedDays[day] = this.closedDays[sourceDay]; // 휴무 여부도 복사
        }
      });
    },

checkDuplicateBizNumber: async function() {
  const payload = {
    bizNumber: {
      part1: this.form.bizPart1,
      part2: this.form.bizPart2,
      part3: this.form.bizPart3
    }
  };

  try {
    const response = await axios.post(`${API_BASE_URL}/api/business-info/check-duplicate`, payload);
    if (response.data.exists) {
      alert('❌ 이미 등록된 사업자번호입니다.');
    } else {
      alert('✅ 사용 가능한 사업자번호입니다.');
    }
  } catch (error) {
    alert('중복 확인 중 오류가 발생했습니다.');
  }
},
addMenuItem(catIdx) {
  this.form.menu[catIdx].items.push({ name: '', price: 0 });
},
removeMenuItem(catIdx, itemIdx) {
  this.form.menu[catIdx].items.splice(itemIdx, 1);
},

applyClosedState(dayKey) {
  if (this.closedDays[dayKey]) {
    this.form.businessHours[dayKey].open = null;
    this.form.businessHours[dayKey].close = null;
    this.form.businessHours[dayKey].lunchStart = null;
    this.form.businessHours[dayKey].lunchEnd = null;
  }
},

// ownerUUID  더 이상 사용안함
async submitForm() {
    // --- 1. 유효성 검사 및 초기 설정 ---
    this.triedSubmit = true;
    if (this.form.addressDetail === '') {
      this.$refs.addressDetailInput.focus();
      return;
    }
    console.log("폼 제출:===============", this.form);

    const ownerSocialId = localStorage.getItem('userUUID');
    if (!ownerSocialId) {
      alert('사용자 정보가 유실되었습니다. 다시 로그인 해주세요.');
      console.error("❌ CRITICAL: 'userUUID'가 localStorage에 없습니다.");
      return;
    }

    if (!this.form.name || !this.form.tel || !this.form.address) {
      alert('필수 항목(매장명, 전화번호, 주소)을 모두 입력해주세요.');
      return;
    }
    // 추가된 필수 필드 (썸네일, 사업자등록증, 통장사본, 계좌정보) 유효성 검사
    if (!this.selectedFile || !this.businessFile || !this.bankCopyFile ||
        !this.settlement.bank || !this.settlement.account || !this.settlement.holder ||
        !this.form.bizPart1 || !this.form.bizPart2 || !this.form.bizPart3) {
      alert('모든 필수 항목(썸네일, 사업자등록증, 통장사본, 계좌정보, 사업자등록번호)을 입력해주세요.');
      return;
    }


    // --- 2. 중복 매장 확인 ---
    try {
      const checkRes = await axios.get(`${API_BASE_URL}/api/barbershops/check-owner`, {
        params: { ownerSocialId }
      });

      if (checkRes.data?.exists && checkRes.data.id) {
        alert('이미 등록된 매장이 있습니다. 수정 페이지로 이동합니다.');
        this.$router.push(`/edit-barbershop/${checkRes.data.id}`);
        return;
      }
    } catch (err) {
      alert('기존 매장 정보 확인 중 문제가 발생했습니다.');
      console.error("❌ 중복 확인 API 실패:", err.response?.data || err.message);
      return;
    }

    console.log('⚠️ check-owner 검사를 통과했음. 이제 신규 등록을 시작합니다.');
    this.isSubmitting = true;

    try {
      const generatedId = Date.now(); // 매장 고유 ID (숫자, URL 등에 사용)

      const cleanedMenu = this.form.menu.map(cat => ({
        category: cat.category,
        items: cat.items.map(item => ({
          name: item.name,
          price: parseInt(item.price.toString().replace(/,/g, ''), 10) || 0
        }))
      }));

      const cleanedBizhourInfo = {};
      Object.entries(this.form.businessHours).forEach(([day, info]) => {
        if (info.open && info.close) {
          cleanedBizhourInfo[day] = { open: info.open, close: info.close };
        }
      });
      const bizhourInfoString = Object.keys(cleanedBizhourInfo).length > 0
        ? JSON.stringify(cleanedBizhourInfo)
        : null;


      // --- 3. 바버샵 정보 등록 (POST) - 먼저 매장을 생성하여 MongoDB _id를 확보합니다. ---
      // (이 페이로드에는 businessType, ownerName 등 민감 정보 포함하지 않습니다)
      const barbershopPayload = {
        id: generatedId, // 숫자 ID
        name: this.form.name,
        tel: this.form.tel,
        address: this.form.address,
        addressDetail: this.form.addressDetail,
        selectedSido: this.form.selectedSido,
        selectedSigungu: this.form.selectedSigungu,
        x: parseFloat(this.form.x),
        y: parseFloat(this.form.y),
        menu: cleanedMenu,
        businessHours: this.form.businessHours,
        bizhourInfo: bizhourInfoString,
        ownerSocialId: ownerSocialId, // 로그인된 사용자 ID
        userId: this.user.kakaoId,     // 백엔드에서 ownerIds에 사용될 ID (필요시)
        // 여기에 settlementAccount, bizNumber 등 민감 정보는 포함하지 않습니다!
      };

      console.log('🧾 [Step 3] Barbershop 등록 요청 payload:==========>>', barbershopPayload);
      const barbershopRes = await axios.post(`${API_BASE_URL}/api/barbershops`, barbershopPayload);
      const createdBarbershopDbId = barbershopRes.data._id; // ✅ MongoDB에서 생성된 Barbershop의 _id!
      const createdBarbershopNumId = barbershopRes.data.id; // 매장의 숫자 id (URL 등에 사용될 수 있음)

      this.barbershopId = createdBarbershopDbId; // 컴포넌트 데이터에 MongoDB _id 저장

      // --- 4. 썸네일 업로드 (일반 매장 사진) ---
      let thumUrl = '';
      if (this.selectedFile) {
        console.log("📸 썸네일 업로드를 시작합니다...");
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('description', '매장 썸네일'); // 썸네일임을 명시

        // ✅ 일반 매장 사진 업로드 API 사용 (barbershops/:id/upload-photo)
        // URL의 ID는 매장의 숫자 ID (createdBarbershopNumId)를 사용합니다.
        const uploadRes = await axios.post(
          `${API_BASE_URL}/api/barbershops/${createdBarbershopNumId}/upload-photo`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true
          }
        );
        thumUrl = uploadRes.data.imageUrl;
        console.log("✅ 썸네일 업로드 완료:", thumUrl);

        // 썸네일 URL을 Barbershop 문서에 업데이트
        await axios.patch(`${API_BASE_URL}/api/barbershops/${createdBarbershopNumId}`, {
          thumUrl: thumUrl,
          selectedSido: this.form.selectedSido,
          selectedSigungu: this.form.selectedSigungu,
          bizhourInfo: bizhourInfoString // 최종 정리된 영업시간 정보
        });
        console.log("✅ 썸네일 URL 및 추가 정보 Barbershop 업데이트 완료!");
      }


      // --- 5. 사업자등록증 파일 업로드 (BusinessInfo 관련) ---
      let registrationFileUrl = '';
      if (this.businessFile) {
          console.log("📄 사업자등록증 업로드를 시작합니다...");
          const formData = new FormData();
          formData.append('file', this.businessFile);
          
          // ❌ [삭제] description 필드는 businessInfo/upload-registration-file 라우터에서 사용되지 않습니다.
          // formData.append('description', '사업자등록증'); // 이 줄은 제거합니다.

          // ✅ businessInfo 전용 라우터 사용
          const uploadRes = await axios.post(
              `${API_BASE_URL}/api/business-info/upload-registration-file`, // ✅ 정확한 라우터 이름
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          registrationFileUrl = uploadRes.data.imageUrl;
          console.log("✅ 사업자등록증 파일 업로드 완료:", registrationFileUrl);
        }

      // --- 6. 통장사본 파일 업로드 (BusinessInfo 관련) ---
      let bankCopyUrl = '';
      if (this.bankCopyFile) {
          console.log("💰 통장사본 업로드를 시작합니다...");
          const formData = new FormData();
          formData.append('file', this.bankCopyFile);
          
          // ❌ [삭제] description 필드는 businessInfo/upload-bank-copy-file 라우터에서 사용되지 않습니다.
          // formData.append('description', '통장사본'); // 이 줄은 제거합니다.
          
          // ✅ businessInfo 전용 라우터 사용
          const uploadRes = await axios.post(
              `${API_BASE_URL}/api/business-info/upload-bank-copy-file`, // ✅ 정확한 라우터 이름
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          bankCopyUrl = uploadRes.data.imageUrl;
          console.log("✅ 통장사본 파일 업로드 완료:", bankCopyUrl);
      }

      // --- 7. BusinessInfo 정보 저장 (민감 정보는 여기에 최종적으로 저장) ---
      const businessInfoPayload = {
        barbershopId: createdBarbershopDbId, // ✅ 방금 생성된 Barbershop의 MongoDB _id (ObjectId 타입)
        userId: this.user.kakaoId, // BusinessInfo에 연결될 사용자 ID
        businessType: this.form.businessType,
        ownerName: this.form.ownerName,
        ownerBirth: this.form.ownerBirth,
        bizNumber: {
          part1: this.form.bizPart1,
          part2: this.form.bizPart2,
          part3: this.form.bizPart3
        },
        category: '이용업', // 고정값
        registrationFileUrl: registrationFileUrl, // 업로드된 사업자등록증 URL
        settlementAccount: {
          bankCode: this.settlement.bank,
          accountNumber: this.settlement.account,
          accountHolder: this.settlement.holder,
          bankCopyUrl: bankCopyUrl // 업로드된 통장사본 URL
        },
        isSameAsShopOwner: this.sameAsOwner // 기타 관련 필드 (필요시)
      };

      console.log('🧾 [Step 7] BusinessInfo 등록 요청 payload:==========>>', businessInfoPayload);
      await axios.post(`${API_BASE_URL}/api/business-info`, businessInfoPayload);
      console.log("✅ BusinessInfo 저장 완료!");

      // --- 8. 최종 성공 처리 ---
      this.formSubmitted = true;
      this.showPopup = true;

    } catch (e) {
      console.error('❌ 등록 절차 실패:', e.response?.data || e.message || e);
      alert('매장 정보 등록 중 서버 오류가 발생했습니다. 관리자에게 문의해주세요.');
    } finally {
      this.isSubmitting = false;
    }
  },




goToDashboard() {
  this.$router.push('/dashboard');
},
  }
};
</script>

<style scoped>
.register-wrapper {
  max-width: 980px;
  margin: 0 auto;
  padding: 24px;
}

.register-container {
  padding: 20px;
  font-family: "Noto Sans KR", sans-serif;
  color: #333;
}

.register-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 10px 20px;
}

.tab-container {
  display: flex;
  margin: 10px 0;
}

.tab {
  padding: 10px 20px;
  margin-right: 5px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: bold;
  color: #5e35b1;
  border-bottom: 3px solid #5e35b1;
}

.section-title {
  font-weight: bold;
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1rem;
  display: flex;
  align-items: flex-start;
}

/*
.form-section {
  border: 1px solid #ccc;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
*/

.form-section {
  border: 1px solid #ddd;
  padding: 24px;
  margin-bottom: 24px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-label {
  width: 100px;
  font-weight: bold;
  margin-right: 10px;
  line-height: 38px;
}

.address-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
}

.form-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
}

.half-width {
  width: 200px;
}

.full-width {
  flex: 1;
  min-width: 250px;
}

.search-button {
  padding: 10px 16px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
}

.required {
  color: red;
  margin-right: 4px;
}

.required-mark {
  color: red;
}

.submit-row {
  text-align: right;
  margin-top: 2rem;
}

.submit-row button {
  padding: 12px 24px;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
}


.popup-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 30px 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.popup-content button {
  margin-top: 16px;
  padding: 10px 20px;
  font-weight: bold;
  background: #5e35b1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.phone-input-box {
  display: flex;
  align-items: center;
  gap: 6px;
}

.verify-button {
  padding: 8px 20px;
  background-color: #007bff; /* 파란색 */
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap; /* 한줄로 나오게 */
  writing-mode: horizontal-tb; /* 혹시 세로모드 방지 */
}

.verification-complete-text {
  font-weight: bold;
  color: #28a745; /* 초록색 */
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap; /* ✅ 이 줄을 추가하여 줄바꿈을 방지합니다. */
}

.form-group.horizontal-align {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.form-input.short-input {
  width: 220px;
}

.checkbox-inline {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.contract-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 24px;
}

.contract-table th,
.contract-table td {
  border: 1px solid #ddd;
  padding: 12px 16px;
  text-align: center;
  font-size: 14px;
}

.contract-table thead {
  background-color: #f9f9f9;
  font-weight: bold;
}
.contract-table.modern-contract {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.08);
}

.contract-table.modern-contract th {
  background-color: #f3f4f6;
  font-weight: bold;
  padding: 14px;
  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #e5e7eb;
}

.contract-table.modern-contract td {
  padding: 14px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
  color: #444;
  font-size: 14px;
  text-align: center;
}

.contract-table.modern-contract tbody tr:hover {
  background-color: #fafafa;
}
.settlement-title {
  margin-top: 40px; /* 수수료 테이블과 제목 사이 간격 */
}

.settlement-section {
  margin-top: 12px; /* 제목과 실제 입력폼 사이 간격 */
}


.bizhour-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
}

.day-label {
  font-weight: bold;
  color: #333;
}

.time-field {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lunch-label {
  font-size: 14px;
  color: #444;
}

.closed-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
